import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faTimes } from '@fortawesome/free-solid-svg-icons';

export const MenuToggle = ({ onClick }) => (
  <button type="button" onClick={onClick}>
    <FontAwesomeIcon icon={faTimes} />
  </button>
);
